/**
 * Create-org failure parsing for onboarding Step 2.
 *
 * safeFetchJSON (packages/shared/src/utils/safeFetch.js) returns a non-2xx as
 * `{ ok: false, data: null, status, error: "HTTP <status>: <raw body text>" }`,
 * so the backend's JSON body ({ error, code }) only exists inside that string.
 */

export const ORG_NAME_TAKEN_CODE = 'ORG_NAME_TAKEN';

function pickBody(parsed) {
  if (parsed && typeof parsed === 'object' && typeof parsed.error === 'string' && parsed.error) {
    return { error: parsed.error, code: parsed.code };
  }
  return null;
}

/**
 * Extract `{ error, code }` from a failed create-org result.
 * Order: a real parsed object body (`result.data`), then JSON after the first
 * `{` in `result.error`, then the raw string with no code.
 */
export function extractCreateOrgErrorBody(result) {
  const fromData = pickBody(result?.data);
  if (fromData) return fromData;
  const raw = typeof result?.error === 'string' ? result.error : '';
  const brace = raw.indexOf('{');
  if (brace !== -1) {
    try {
      const fromString = pickBody(JSON.parse(raw.slice(brace)));
      if (fromString) return fromString;
    } catch {
      /* not JSON, fall through to the raw string */
    }
  }
  return { error: raw, code: undefined };
}
